export default "__VITE_ASSET__BwCePvlg__"